<template>
  <div id="app">
    <!-- <div class="app-header">
      <div class="header-container">
        <div class="logo-section">
          <h2 class="app-title" @click="goToHome">藏经阁</h2>
        </div>
        
        <div class="user-actions">
          <template v-if="currentUser">
            <div class="user-info">
              <span class="username">{{ currentUser ? currentUser.username : '' }}</span>
              <el-button type="text" @click="handleLogout" class="logout-btn">退出</el-button>
            </div>
          </template>
          <el-button v-else type="primary" @click="goToLogin" class="login-btn">登录</el-button>
        </div>
      </div>
    </div> -->
    <div class="main-content">
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <component :is="Component" v-if="route.meta.keepAlive" :key="route.path" />
          </keep-alive>
        </transition>
        <transition name="fade" mode="out-in">
          <component :is="Component" v-if="!route.meta.keepAlive" :key="route.path" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { isLoggedIn, getUser, logout } from '@/api/auth';
import emitter from '@/utils/eventBus';

const router = useRouter();
const currentUser = ref(null);

const checkLoginStatus = () => {
  if (isLoggedIn()) {
    currentUser.value = getUser();
  } else {
    currentUser.value = null;
  }
};

onMounted(() => {
  checkLoginStatus();
  // Listen for login events
  emitter.on('login-success', () => {
    checkLoginStatus();
  });
});

const goToLogin = () => {
  router.push('/login');
};

const goToHome = () => {
  router.push('/');
};

const handleLogout = () => {
  logout();
  currentUser.value = null;
  ElMessage.success('已退出登录');
  router.push('/');
};
</script>

<style>
/* Global styles */
:root {
  --primary-color: #3b82f6;
  --bg-color: #555555;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --border-color: #e2e8f0;
  --header-height: 0;
}

body {
  margin: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: var(--bg-color);
  color: var(--text-primary);
}

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.app-header {
  height: var(--header-height);
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.header-container {
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo-section {
  cursor: pointer;
}

.app-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-color);
  letter-spacing: 0.5px;
}

.user-actions {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.username {
  font-size: 14px;
  color: var(--text-secondary);
}

.login-btn {
  font-weight: 500;
}

.logout-btn {
  color: var(--text-secondary);
}

.logout-btn:hover {
  color: #ef4444;
}

.main-content {
  margin-top: var(--header-height);
  flex: 1;
  height: calc(100vh - var(--header-height));
  overflow: hidden;
  background-color: var(--bg-color);
}

/* Scrollbar styles */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
